import CustomTabs from "../../../components/CustomTabs/CustomTabs.js";
import Tasks from "../../../components/Tasks/Tasks.js";
import GridItem from "../../../components/Grid/GridItem.js";
import DateRangeIcon from '@material-ui/icons/DateRange';
import MDBox from "components/MDBox";
import CircularProgress from '@mui/material/CircularProgress';

import { useTranslation } from "react-i18next";
function StoreReportVendors(props) {

  const { t }        = useTranslation();
 
  let vendorReportDataToday   = [];
  let vendorReportDataWeek    = [];
  let vendorReportDataMonth   = [];
  let vendorReportDataYear    = [];
  let vendorReportDataAllTime = [];

  let vendorsObjectToday      = props.vendorsObjectToday;
  let vendorsObjectWeek       = props.vendorsObjectWeek;
  let vendorsObjectMonth      = props.vendorsObjectMonth;
  let vendorsObjectYear       = props.vendorsObjectYear;
  let vendorsObjectAllTime    = props.vendorsObjectAllTime;
  let isVendorsLoading        = props.isVendorsLoading;
  let tabOnClick              = props.tabOnClick;

  if(Object.keys(vendorsObjectToday).length > 0)
  {
    vendorReportDataToday = [
      t("Total Vendors")+' : '+vendorsObjectToday.totalVendorsCount,
      t("Approved Vendors")+' : '+vendorsObjectToday.totalApprovedVendorsCount,
      t("Disapproved Vendors")+' : '+vendorsObjectToday.totalInactiveVendorsCount,
      t("Pending Vendors")+' : '+vendorsObjectToday.totalPendingVendorsCount,    
    ];
  }

  if(Object.keys(vendorsObjectWeek).length > 0)
  {
    vendorReportDataWeek = [
      t("Total Vendors")+' : '+vendorsObjectWeek.totalVendorsCount,
      t("Approved Vendors")+' : '+vendorsObjectWeek.totalApprovedVendorsCount,
      t("Disapproved Vendors")+' : '+vendorsObjectWeek.totalInactiveVendorsCount,
      t("Pending Vendors")+' : '+vendorsObjectWeek.totalPendingVendorsCount,    
    ];
  }

  if(Object.keys(vendorsObjectMonth).length > 0)
  {
    vendorReportDataMonth = [
      t("Total Vendors")+' : '+vendorsObjectMonth.totalVendorsCount,
      t("Approved Vendors")+' : '+vendorsObjectMonth.totalApprovedVendorsCount,
      t("Disapproved Vendors")+' : '+vendorsObjectMonth.totalInactiveVendorsCount,
      t("Pending Vendors")+' : '+vendorsObjectMonth.totalPendingVendorsCount,    
    ];
  }

  if(Object.keys(vendorsObjectYear).length > 0)
  {
    vendorReportDataYear = [
      t("Total Vendors")+' : '+vendorsObjectYear.totalVendorsCount,
      t("Approved Vendors")+' : '+vendorsObjectYear.totalApprovedVendorsCount,
      t("Disapproved Vendors")+' : '+vendorsObjectYear.totalInactiveVendorsCount,
      t("Pending Vendors")+' : '+vendorsObjectYear.totalPendingVendorsCount,    
    ];
  }

  if(Object.keys(vendorsObjectAllTime).length > 0)
  {
    vendorReportDataAllTime = [
      t("Total Vendors")+' : '+vendorsObjectAllTime.totalVendorsCount,
      t("Approved Vendors")+' : '+vendorsObjectAllTime.totalApprovedVendorsCount,
      t("Disapproved Vendors")+' : '+vendorsObjectAllTime.totalInactiveVendorsCount,
      t("Pending Vendors")+' : '+vendorsObjectAllTime.totalPendingVendorsCount,    
    ];
  }  

  return (
      (
        vendorReportDataToday.length > 0 || 
        vendorReportDataWeek.length > 0 || 
        vendorReportDataMonth.length > 0 || 
        vendorReportDataYear.length > 0 || 
        vendorReportDataAllTime.length > 0       
      ) ? 
        <GridItem xs={12} sm={6} className="rowTableCell">

          {isVendorsLoading ?       
            <MDBox py={3} sx={{ textAlign: "center", position: "absolute", top: 75, zIndex: 100, width: "100%" }}>   
              <CircularProgress size={30} style={{color: '#1a90ff', margin: '0px auto'}}/>
            </MDBox>
          : null}

          <CustomTabs
            title={t("Store Statistics Vendors")+" : "}
            headerColor="rose"
            tabOnClick={tabOnClick}
            tabs={[
              {                
                tabName: "Today",
                tabValue: "today",
                tabSection: "vendors",
                tabIcon: DateRangeIcon,                
                tabContent: (
                  <Tasks
                    tasksIndexes={[0, 1, 2, 3]}
                    tasks={vendorReportDataToday}
                  />
                ),
              },
              {
                tabName: "This Week",
                tabValue: "week",
                tabSection: "vendors",
                tabIcon: DateRangeIcon,
                tabContent: (
                  <Tasks
                    tasksIndexes={[0, 1, 2, 3]}
                    tasks={vendorReportDataWeek}
                  />
                ),
              },
              {
                tabName: "This Month",
                tabValue: "month",
                tabSection: "vendors",                
                tabIcon: DateRangeIcon,
                tabContent: (
                  <Tasks
                    tasksIndexes={[0, 1, 2, 3]}
                    tasks={vendorReportDataMonth}
                  />
                ),
              },
              {
                tabName: "This Year",
                tabValue: "year",
                tabSection: "vendors",                 
                tabIcon: DateRangeIcon,
                tabContent: (
                  <Tasks
                    tasksIndexes={[0, 1, 2, 3]}
                    tasks={vendorReportDataYear}
                  />
                ),
              },
              {
                tabName: "All Time",
                tabValue: "all-time",
                tabSection: "vendors",                 
                tabIcon: DateRangeIcon,
                tabContent: (
                  <Tasks
                    tasksIndexes={[0, 1, 2, 3]}
                    tasks={vendorReportDataAllTime}
                  />
                ),
              },
            ]}
          />
        </GridItem> 
      : <></>
  )
}

export default StoreReportVendors;